<template lang="html">
  <main>
    Thank you for your order
    <br>
    {{ orderDetails.created | moment }}
    <br><br>
    {{ orderDetails }}
  </main>
</template>

<script>
import axios from 'axios';
import moment from 'moment';
export default {
  data() {
    return {
      orderDetails: false
    };
  },
  created() {
    var charge_id = this.$route.params.id;
    axios.get(`${window.endpoint}/charge/${charge_id}`)
      .then((res) => {
        this.orderDetails = res.data.charge;
      });
  },
  filters: {
    moment(date) {
      return moment.unix(date).format('MMMM Do, YYYY - h:mm a');
    },
    currency(amount) {
      return `${(amount/100).toFixed( 2 )}`;
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
